import React from "react";
import "./BridalMakeUpPackageProcess.css"
const BridalMakeUpPackageProcess = () => {
  return (
    <div className="bridalMakeUpPackageHeading">
      <h4>The Process: From Consultation to the Big Day</h4>
      <p>
        Our Bridal Makeup Packages in Bangalore follow a structured process to
        ensure everything goes smoothly:
      </p>
      <ul>
        <li>
          <h6>1. Initial Consultation:</h6> This is where we get to know you and
          your vision for your wedding day. We discuss your preferences, wedding
          theme, and any specific looks you have in mind.
        </li>
        <li>
          <h6>2. Trial Session:</h6> During the trial session, we test different
          makeup styles and hairdos to find the perfect look. This session is
          essential to ensure you are completely satisfied with your final look.
        </li>
        <li>
          <h6>3. Pre-Wedding Treatments:</h6> In the weeks leading up to your
          wedding, we provide skin and hair treatments to ensure you are in the
          best possible condition for your big day.
        </li>
        <li>
          <h6> 4. Wedding Day Preparation:</h6> On your wedding day, our team
          arrives at your location to provide makeup and hair services. We
          ensure that you are ready on time and look flawless throughout the
          day.
        </li>
        <li>
          <h6> 5. Final Touch-Ups:</h6> Just before you walk down the aisle, we
          provide final touch-ups to ensure your makeup and hair are perfect.
        </li>
      </ul>
    </div>
  );
};

export default BridalMakeUpPackageProcess;
